import Component from '../core/Component'
import throttle from 'lodash/throttle'
import EventBus from '../core/EventBus'
import { getScrollTop } from '../services/Viewport/scroll'

const STATES = {
    PINNED: 'is-pinned',
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible'
}

export default class Header extends Component {
    constructor(element) {
        super(element)

        this.isPinned = false
        this.isVisible = true
        this.currentOffset = 0
        this.isDisabled = false
    }

    prepare() {
        window.addEventListener('scroll', this.handleScroll, {
            passive: true
        })
        EventBus.on('scroll:start', this.handleScrollStart)
        EventBus.on('scroll:stop', this.handleScrollStop)
    }

    destroy() {
        window.removeEventListener('scroll', this.handleScroll, {
            passive: true
        })
        EventBus.off('scroll:start', this.handleScrollStart)
        EventBus.off('scroll:stop', this.handleScrollStop)
    }

    handleScroll = ({offset}) => {

        offset = getScrollTop()

        if (offset > 160) {
            if (!this.isPinned) {
                this.pin()
            }
        } else if (offset <= 0) {
            if (this.isPinned) {
                this.unpin()
            }
        }

        if (offset < this.currentOffset && !this.isDisabled) {
            if (!this.isVisible) {
                this.show()
            }
        }

        if (offset > this.currentOffset && !this.isDisabled) {
            if (this.isVisible) {
                this.hide()
            }
        }

        this.currentOffset = offset
    }

    handleScrollStart = () => {
        this.disable()
    }

    handleScrollStop = () => {
        this.enable()
    }

    pin() {
        this.isPinned = true
        this.element.classList.add(STATES.PINNED)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        this.emit('pin:change', {
            pinned: true
        })
    }

    unpin() {
        this.isPinned = false
        this.isVisible = false
        this.element.classList.remove(STATES.PINNED)
        this.element.classList.remove(STATES.ACTIVE)
        this.element.classList.remove(STATES.VISIBLE)
        this.emit('pin:change', {
            pinned: false
        })
    }

    show() {
        this.isVisible = true
        this.element.classList.add(STATES.VISIBLE)
        this.emit('show')
    }

    hide() {
        this.isVisible = false
        this.element.classList.remove(STATES.VISIBLE)
        this.emit('hide')
    }

    disable() {
        this.isDisabled = true
        if (this.isVisible) {
            this.hide()
        }
    }

    enable() {
        this.isDisabled = false
    }

    getHeight() {
        const box = this.element.getBoundingClientRect()
        return box.top + box.height
    }
}